import {
  RelationshipStatus,
  ProfessionStatus,
  HealthInsuranceStatus,
  HousingSituation,
  MobilityStatus,
  PropertyOwnership,
  ProvisionTarget,
  MiscellaneousProperty,
  Pet,
} from '../../enum';

export class ClientFinancialProfileModel {
  relationshipStatus?: RelationshipStatus | null;
  professionStatus?: ProfessionStatus | null;
  healthInsuranceStatus?: HealthInsuranceStatus | null;
  childrenAmount?: number | null;
  childBenefit?: number | null;
  housingSituation?: HousingSituation | null;
  mobilityStatuses: MobilityStatus[] = [];
  propertyOwnerships: PropertyOwnership[] = [];
  provisionTargets: ProvisionTarget[] = [];
  miscellaneousProperties: MiscellaneousProperty[] = [];
  pets: Pet[] = [];
}
